<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="popupTitle" width="600px" @close="close">
    <div slot="content">
      <el-form :model="serverImageInfo" label-position="top" ref="serverImageForm" :rules="formRules">
        <el-row :gutter="20">
          <!-- <el-col :span="8">
            <el-form-item label="서버 이미지명" prop="imageName">
              <el-input v-model="serverImageInfo.imageName" placeholder="이미지명을 입력하세요" />
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="공개 여부" prop="showFlag">
              <el-switch v-model="serverImageInfo.showFlag" active-value="1" inactive-value="0" style="height:28px"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="운영체제 종류" prop="os">
              <el-select v-model="serverImageInfo.os" style="width: 100%">
                <el-option v-for="type in osList" :key="type.swId" :value="type.swId" :label="type.swName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="DBMS 종류" prop="dbms">
              <el-select v-model="serverImageInfo.dbms" clearable style="width: 100%">
                <el-option v-for="type in dbmsList" :key="type.swId" :value="type.swId" :label="type.swName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="WAS 종류" prop="was">
              <el-select v-model="serverImageInfo.was" clearable style="width: 100%">
                <el-option v-for="type in wasList" :key="type.swId" :value="type.swId" :label="type.swName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="이미지 설명" prop="imageDesc">
            <el-input type="textarea" :rows="4" v-model="serverImageInfo.imageDesc" placeholder="설명을 입력하세요" />
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { cloneDeep, forEach, isEqual } from 'lodash';
import msgUtil from '@/utils/message';
import VirtualServiceSettingAPI from '@/api/settings/virtual/virtual-service-settings';

export default {
  name: 'WServerImageSettingPopup',
  props: {
    popupParams: {
      type: Object,
    },
    osList: {
      type: Array,
    },
    dbmsList: {
      type: Array,
    },
    wasList: {
      type: Array,
    },
  },
  data() {
    const formRules = {
      showFlag: [
        { required: true, message: '필수 정보입니다.', trigger: 'change' },
      ],
      os: [
        { required: true, message: '필수 정보입니다.', trigger: 'change' },
      ],
    };
    return {
      popupTitle: '',
      formRules,
      serverImageInfo: {
        showFlag: '0',
        os: null,
        dbms: null,
        was: null,
        imageDesc: null,
        settingCompleteFlag: false,
      },
    };
  },
  methods: {
    open() {
      this.$nextTick(() => {
        const popupType = this.popupParams.popupType;
        this.popupTitle = `서버 이미지 ${popupType === 'ADD' ? '추가' : '수정'}`;
        if (popupType === 'UPDATE') {
          this.serverImageInfo = cloneDeep(this.popupParams.selectedRow);
        }
      });
      this.loadData();
      this.$refs.slidingPopup.visible = true;
    },
    close() {
      this.initData();
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 정보 초기화
     * @author najongdang
     * @return {[type]} [description]
     */
    initData() {
      this.settingCompleteFlag = false;
      this.serverImageInfo = {
        showFlag: '0',
        os: null,
        dbms: null,
        was: null,
        imageDesc: null,
      };
      this.$refs.serverImageForm.resetFields();
    },
    loadData() {
    },
    /**
     * 저장 버튼 클릭
     * @author najongdang
     * @return {[type]} [description]
     */
    onSaveButton() {
      this.settingCompleteFlag = true;
      this.$refs.serverImageForm.validate().then((success) => {
        if (success) {
          VirtualServiceSettingAPI.checkServerImageDuplication(this.serverImageInfo).then((response) => {
            const result = response.data;
            if (result.success) {
              if (result.data) {
                this.vmsImageSet();
              } else {
                this.$message(msgUtil.getCustomMsgData('이미 존재하는 서버 이미지입니다.', false));
              }
            }
          }).catch(() => {
          });
        }
      }).catch(() => {});
    },
    vmsImageSet() {
      const popupType = this.popupParams.popupType;
      const serverImageInfo = this.serverImageInfo;
      const messageName = '서버 이미지';
      if (popupType === 'ADD') {
        VirtualServiceSettingAPI.insertVmsImage(serverImageInfo).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, messageName, true));
            this.$emit('reload');
            this.close();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, messageName, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, messageName, false));
        });
      } else if (popupType === 'UPDATE') {
        const originServerImage = this.popupParams.selectedRow;
        let isModified = false;
        forEach(serverImageInfo, (value, key) => {
          if (!isEqual(originServerImage[key], value)) {
            isModified = true;
          }
        });
        if (isModified) {
          VirtualServiceSettingAPI.updateVmsImage({
            imageId: serverImageInfo.imageId,
            ...serverImageInfo,
          }).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, messageName, true));
              this.$emit('reload');
              this.close();
            }
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, messageName, false));
          });
        } else {
          this.close();
        }
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/VirtualService/ServerImageSetting/popup/ServerImageSettingPopup.vue